export const parseMarketOrderStatus = (value) => {
	let newValue = '';
	switch (value) {
		case 'PAYED':
			newValue = '결제완료';
			break;
		case 'ORDER_WAITING':
			newValue = '발주준비중';
			break;
		case 'DELIVERY_WAITING':
			newValue = '출고준비중';
			break;
		case 'DELIVERING':
			newValue = '배송중';
			break;
		case 'DELIVERED':
			newValue = '배송완료';
			break;
		case 'PURCHASE_DECIDED':
			newValue = '구매확정';
			break;
		case 'CANCEL_REQUEST':
			newValue = '취소요청';
			break;
		case 'CANCELED':
			newValue = '취소완료';
			break;
		case 'EXCHANGE_REQUEST':
			newValue = '교환요청';
			break;
		case 'EXCHANGE_REDELIVERING':
			newValue = '교환중';
			break;
		case 'EXCHANGED':
			newValue = '교환완료';
			break;
		case 'RETURN_REQUEST':
			newValue = '반품요청';
			break;
		case 'COLLECTING':
			newValue = '반품중';
			break;
		case 'RETURNED':
			newValue = '반품완료';
			break;
		case 'ORDERED':
			newValue = '발주완료';
			break;
		case 'RELEASED':
			newValue = '출고완료';
			break;
		case 'ERROR':
			newValue = '오류';
			break;
		default:
			newValue = value;
	}
	return newValue;
};
export const changeMarketData = (value) => {
	let newValue = '';
	if (value === 'smartstore') {
		newValue = '스마트스토어';
	} else if (value === 'eleventh') {
		newValue = '11번가';
	} else if (value === 'coupang') {
		newValue = '쿠팡';
	} else if (value === 'kbpay') {
		newValue = '국민카드몰';
	} else if (value === 'imembers') {
		newValue = '아이멤버스';
	} else if (value === 'showdam') {
		newValue = '쇼담';
	} else if (value === 'aphrozone') {
		newValue = '아프로존';
	}
	return newValue;
};
export const changeSaleStatusData = (value) => {
	let newValue = '';
	switch (value) {
		case 'SALE':
			newValue = '판매중';
			break;
		case 'SOLDOUT, EXTINCTION':
			newValue = '판매중지';
			break;
		case 'SOLDOUT':
			newValue = '품절';
			break;
		case 'EXTINCTION':
			newValue = '단종';
			break;
		case 'EXCEPTION':
			newValue = '판매제외';
			break;
		default:
			newValue = value;
	}
	return newValue;
};

export const changePeriodData = (value) => {
	let newValue = '';
	switch (value) {
		case '등록기간':
			newValue = 'regDate';
			break;
		case '수정기간':
			newValue = 'updDate';
			break;
		default:
			newValue = value;
	}
	return newValue;
};

export const parseNumber = (num) => {
	let phone;
	if (num) phone = [num.slice(0, -8), num.slice(-8, -4), num.slice(-4)].join('-');

	return phone;
};

export const parseVendorOrderStatus = (value) => {
	let newValue = '';
	switch (value) {
		case 'ORDER_WAITING':
			newValue = '발주대기';
			break;
		case 'ORDERED':
			newValue = '발주완료';
			break;
		case 'RELEASED':
			newValue = '출고완료';
			break;
		case 'ERROR':
			newValue = '오류';
			break;
		default:
			newValue = value;
	}
	return newValue;
};

export const changeDeliveryCompany = (value) => {
	let newValue = '';
	switch (value) {
		case 'HANJIN':
			newValue = '한진택배';
			break;
		case 'HYUNDAI':
			newValue = '롯데택배';
			break;
		case 'CJGLS':
			newValue = 'CJ대한통운';
			break;
		case 'KDEXP':
			newValue = '경동택배';
			break;
		case 'DAESIN':
			newValue = '대신택배';
			break;
		case 'KGB':
			newValue = '로젠택배';
			break;
		default:
			newValue = value;
	}
	return newValue;
};

export const changeDelivaryType = (value) => {
	let newValue = '';
	switch (value) {
		case 'PREPAID':
			newValue = '선결제';
			break;
		case 'COD':
			newValue = '착불';
			break;
		case 'FREE':
			newValue = '무료';
			break;
		default:
			newValue = value;
	}
	return newValue;
};
export const changePriceNoUnit = (value = 0) => {
	const reg = /^[0-9]+$/;
	let str = Number(value);
	if (reg.test(str)) {
		const regexp = /\B(?=(\d{3})+(?!\d))/g;
		return str.toString().replace(regexp, ',');
	} else {
		return str;
	}
};
export const changePrice = (value = 0) => {
	const reg = /^[0-9]+$/;
	let str = Number(value);
	if (reg.test(str)) {
		const regexp = /\B(?=(\d{3})+(?!\d))/g;
		return str.toString().replace(regexp, ',') + ' 원';
	} else {
		return str + ' 원';
	}
};
export const changeCountNumber = (value = 0) => {
	const reg = /^[0-9]+$/;
	let str = Number(value);
	if (reg.test(str)) {
		const regexp = /\B(?=(\d{3})+(?!\d))/g;
		return str.toString().replace(regexp, ',') + ' 개';
	} else {
		return str + ' 개';
	}
};
export const changeTelNumber = (number) => {
	let phone;
	let newNumber = number?.replace(/-/g, '').trim();

	if (newNumber && newNumber.length === 11) phone = newNumber.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
	else if (newNumber && newNumber.length > 11) phone = [newNumber.slice(0, -8), newNumber.slice(-8, -4), newNumber.slice(-4)].join('-');

	return phone;
};

//모달창 스크롤방지 함수
export const preventScroll = () => {
	const currentScrollY = window.scrollY;
	document.body.style.position = 'fixed';
	document.body.style.width = '100%';
	document.body.style.top = `-${currentScrollY}px`; // 현재 스크롤 위치
	document.body.style.overflowY = 'scroll';
	return currentScrollY;
};
//모달창 스크롤방지 해제 함수
export const allowScroll = (prevScrollY) => {
	document.body.style.position = '';
	document.body.style.width = '';
	document.body.style.top = '';
	document.body.style.overflowY = '';
	window.scrollTo(0, prevScrollY);
};
//모달창 스크롤방지 함수
export const preventModalScroll = () => {
	const modal = document.querySelector('.slide-modal');
	const currentScrollY = modal.scrollY;
	modal.style.position = 'fixed';
	modal.style.width = '100%';
	modal.style.top = `-${currentScrollY}px`; // 현재 스크롤 위치
	return currentScrollY;
};
//모달창 스크롤방지 해제 함수
export const allowModalScroll = (prevScrollY) => {
	const modal = document.querySelector('.slide-modal');
	modal.style.position = '';
	modal.style.width = '';
	modal.style.top = '';
	modal.scrollTo(0, prevScrollY);
};

//상품등록 상태
export const changeMarketState = (value) => {
	let newValue = '';
	switch (value) {
		case 'ready':
			newValue = '준비';
			break;
		case 'processing':
			newValue = '작업중';
			break;
		case 'error':
			newValue = '오류';
			break;
		case 'fail':
			newValue = '실패';
			break;
		case 'done':
			newValue = '완료';
			break;
		default:
			newValue = value;
	}
	return newValue;
};
